export default __webpack_public_path__ + "static/media/icon_sort.122f76e6.svg";